import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles(() => ({
    pagination: {
        overflow: 'visible',
        width: '100%',
        '& .MuiTablePagination-displayedRows': {
            margin: 0,
        },
    },
}));
//# sourceMappingURL=TablePagination.styles.js.map